import React from 'react'
// import BreadCrumb from '../../components/Global/Breadcrumb/BreadCrumb'
import AllBlogTags from './AllBlogTags'

function AllTags() {
    return (
        <div>
            <AllBlogTags />
        </div>
    )
}

export default AllTags
